import React from 'react';

import { KeyOutlined, LockOutlined, SafetyOutlined } from '@ant-design/icons';
import { Form, Input, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

import { useDirtyMaskedField } from '@hooks/shared/useDirtyMaskedField';

const PchomeCredentials = ({ form, ecAccount }) => {
  const { t } = useTranslation();

  const isEditing = !!ecAccount?.id;
  const aesIvDirty = useDirtyMaskedField(form, [ 'credentials', 'aes_iv' ], isEditing);

  return (
    <div>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name={['credentials', 'vendor_id']}
            label={t('models.ec_account.platform_settings.pchome.vendor_id')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.pchome.vendor_id_required') }]}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.pchome.vendor_id_placeholder')}
              prefix={<SafetyOutlined />}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'aes_key']}
            label={t('models.ec_account.platform_settings.pchome.aes_key')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.pchome.aes_key_required') }]}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.pchome.aes_key_placeholder')}
              prefix={<KeyOutlined />}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'aes_iv']}
            label={t('models.ec_account.platform_settings.pchome.aes_iv')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.pchome.aes_iv_required') }]}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.pchome.aes_iv_placeholder')}
              prefix={<LockOutlined />}
              visibilityToggle={aesIvDirty}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default PchomeCredentials;
